import { Component, Input, OnInit, Inject, AfterViewInit } from '@angular/core';
import { DocumentService } from '../../../../../../UI/src/app/shared/document-upload/document-upload.service';
// import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';
import { ViewController, NavParams } from 'ionic-angular';

@Component({
  selector: 'sts-submit-alert-dialog',
  templateUrl: './submit-alert-dialog.component.html',
  providers: [DocumentService]
})
export class SubmitAlertDialogComponent implements OnInit, AfterViewInit {
  showLoader = false;  
  private documentType: any;
  constructor(
    private documentService: DocumentService,
    public viewCtrl: ViewController,
    public params: NavParams
  ) { }

  ngAfterViewInit() {
    setTimeout(() => {
      let elm = <HTMLDivElement>document.querySelector('ion-modal div');
      elm.setAttribute('tabindex', '-1');
      elm.setAttribute('role', 'dialog');
      elm.focus();
    }, 300);
  }

  public submitData(data) {
    this.showLoader = true;
    this.documentType = this.params.data["data"];
    this.documentService.saveDocumentTypes(this.documentType, true).subscribe(
      (response) => {
        this.close(true);
      }, (error) => {
        this.close(false);   
      }
    );
  };

  close(value) {
    this.viewCtrl.dismiss(value);
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/candidate-profile/submit-alert-dialog/submit-alert-dialog.component.ts